import Axios, { AxiosError, AxiosRequestConfig } from "axios";

interface ApiResponse {
  data?: any;
  error?: AxiosError;
}

// Extend AxiosRequestConfig to include formData property
interface RequestConfig extends AxiosRequestConfig {
  formData?: boolean; // Optional property indicating if this request uses FormData
  dispatch?: any;
}

const ApiHelperFunction = async ({
  url,
  method,
  data,
  params,
  formData,
  dispatch,
  headers,
}: RequestConfig): Promise<ApiResponse> => {
  try {
    Axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL; // Use env variable for baseURL

    let requestObj: AxiosRequestConfig = { url, method, data, params };

    // Skips ngrok's browser-warning interstitial when REACT_APP_API_BASE_URL
    // points at an *.ngrok-free.dev tunnel — without it ngrok answers browser
    // requests with an HTML page instead of the API response. Harmless on
    // non-ngrok hosts.
    requestObj.headers = { "ngrok-skip-browser-warning": "true" };

    // Check if payload type has formData then append headers key
    if (formData) {
      requestObj.headers = {
        ...requestObj.headers,
        "Content-Type": "multipart/form-data",
      };
    }
    if (headers) {
      requestObj.headers = {
        ...requestObj.headers,
        ...headers,
        //  "Bypass-Tunnel-Reminder": "true",
      };
    }

    const result = await Axios(requestObj);
    return { data: result.data };
  } catch (axiosError) {
    const error = axiosError as AxiosError;

    if (error?.response) {
      if (error?.response?.status === 401) {
        localStorage.clear();

        // Optional: Dispatch a logout/reset action here if needed
        // dispatch?.(logoutUser());

        // Redirect to login page
        window.location.href = "/login";
      }
      throw error?.response;
    } else {
      throw error;
    }
  }
};

export default ApiHelperFunction;
